import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { ColorThemeEnum } from '@/enum/ColorThemeEnum';
import { BubbleStyleZod } from '@/types/BubbleStyleType';

const QuotationZod = z.object({
  __component: z.literal('block.quotation'),
  id: z.number(),
  logo: MediaZod,
  quote: z.string(),
  author: z.string(),
  role: z.string(),
  colorText: z.enum([ColorThemeEnum.WHITE, ColorThemeEnum.BLACK]),
  bubbleStyle: BubbleStyleZod,
});

export { QuotationZod };
export type QuotationType = z.infer<typeof QuotationZod>;
